module.exports = __webpack_public_path__ + "system/img/personal-icon-04.a4d1ebe6.png";